import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// A single MSAL instance is shared by React and the authenticated API client.
export const msalInstance = new PublicClientApplication(msalConfig);
